import { useEffect, useState } from "react";
import { Container, Row, Col, Card, Badge, Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUser, faGraduationCap, faChartLine, faCalendarCheck, faCalendarTimes, faUsers, faBook, faTrophy, faSignOutAlt } from "@fortawesome/free-solid-svg-icons";
import '../styles/profile.css';
import BinocularsLoader from "./BinocularsLoader";

function ParentDashboard({ style }) {
  const [studentData, setStudentData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    window.scrollTo(0, 0);
    
    // جلب بيانات الطالب من localStorage
    const savedData = localStorage.getItem('studentData');
    const parentPhone = localStorage.getItem('parentPhone');
    
    if (savedData && parentPhone) {
      const parsedData = JSON.parse(savedData);
      console.log('Student Data:', parsedData);
      console.log('Student Info:', parsedData.student_info);
      setStudentData(parsedData);
      setIsLoading(false);
    } else {
      // إذا لم تكن البيانات موجودة، إعادة توجيه لتسجيل الدخول
      console.log('No data found, redirecting to parent login');
      window.location.href = '/#/parent-login';
    }
  }, []);

  // دالة تسجيل الخروج
  const handleLogout = () => {
    // مسح جميع البيانات من localStorage
    localStorage.clear();
    
    // إعادة توجيه إلى صفحة تسجيل الدخول
    window.location.href = '/#/parent-login';
  };

  // حساب الإحصائيات العامة
  const calculateOverallStats = () => {
    if (!studentData?.overall_statistics) return {};

    const stats = studentData.overall_statistics;
    return {
      totalCourses: stats.total_courses || 0,
      attendedCourses: stats.attended_courses || 0,
      absentCourses: stats.absent_courses || 0,
      attendanceRate: stats.attendance_rate || 0,
      onlineAttendance: stats.online_attendance || 0,
      centerAttendance: stats.center_attendance || 0,
      averageGrade: stats.average_exam_degree || '0%'
    };
  };

  const stats = calculateOverallStats();

  if (isLoading) {
    return (
      <div className={`main-loading ${style ? 'dark-mode' : ''}`}>
        <div className="loading-course">
          <BinocularsLoader style={style} />
        </div>
      </div>
    );
  }

  console.log('Student Data:', studentData);

  return (
    <>
      <div className={`profile-page ${style ? 'dark-mode' : ''}`}>
        <main className="profile-main-content">
          <Container fluid>
            {/* معلومات الطالب */}
                 <div className="page-header">
                   <div className="header-icon-wrapper">
                     <FontAwesomeIcon icon={faUser} />
                   </div>
                   <div className="header-text">
                     <h1>لوحة تحكم ولي الأمر</h1>
                     <p>متابعة تقدم ابنك/ابنتك في التعلم</p>
                     <Button 
                       variant="outline-danger" 
                       size="sm" 
                       onClick={handleLogout}
                       className="logout-btn mt-2"
                     >
                       <FontAwesomeIcon icon={faSignOutAlt} className="me-1" />
                       تسجيل الخروج
                     </Button>
                {studentData?.student_info ? (
                  <div className="student-info mt-3">
                    <p><strong>اسم الطالب:</strong> {studentData.student_info.first_name + ' ' + studentData.student_info.last_name || 'غير محدد'}</p>
                    <p><strong>رقم الهاتف:</strong> {studentData.student_info.phone || 'غير محدد'}</p>
                    <p><strong>رقم ولي الأمر:</strong> {studentData.student_info.parent_phone || 'غير محدد'}</p>
                    <p><strong>السنتر:</strong> {studentData.student_info.center || 'غير محدد'}</p>
                    {/* <p><strong>المستوى:</strong> {studentData.student_info.level || 'غير محدد'}</p> */}
                  </div>
                ) : (
                  <div className="student-info mt-3">
                    <p><strong>تحميل البيانات...</strong></p>
                  </div>
                )}
              </div>
            </div>

            {/* الإحصائيات العامة */}
            <Row className="mb-4">
              <Col md={3} sm={6} className="mb-3">
                <Card className="attendance-stat-card">
                  <Card.Body>
                    <div className="stat-icon attended">
                      <FontAwesomeIcon icon={faCalendarCheck} />
                    </div>
                    <h4>{stats.attendedCourses}</h4>
                    <p>حضور</p>
                  </Card.Body>
                </Card>
              </Col>
              <Col md={3} sm={6} className="mb-3">
                <Card className="attendance-stat-card">
                  <Card.Body>
                    <div className="stat-icon absent">
                      <FontAwesomeIcon icon={faCalendarTimes} />
                    </div>
                    <h4>{stats.absentCourses}</h4>
                    <p>غياب</p>
                  </Card.Body>
                </Card>
              </Col>
              <Col md={3} sm={6} className="mb-3">
                <Card className="attendance-stat-card">
                  <Card.Body>
                    <div className="stat-icon percentage">
                      <FontAwesomeIcon icon={faChartLine} />
                    </div>
                    <h4>{stats.attendanceRate}%</h4>
                    <p>نسبة الحضور</p>
                  </Card.Body>
                </Card>
              </Col>
              <Col md={3} sm={6} className="mb-3">
                <Card className="attendance-stat-card">
                  <Card.Body>
                    <div className="stat-icon grade">
                      <FontAwesomeIcon icon={faTrophy} />
                    </div>
                    <h4>{stats.averageGrade}</h4>
                    <p>متوسط الدرجات</p>
                  </Card.Body>
                </Card>
              </Col>
            </Row>

            {/* جدول الحضور */}
            <div className="attendance-table-container">
              <div className="attendance-table-header">
                <div className="table-header-cell">
                  <FontAwesomeIcon icon={faCalendarCheck} />
                  <span>التاريخ</span>
                </div>
                <div className="table-header-cell">
                  <FontAwesomeIcon icon={faUsers} />
                  <span>المجموعة</span>
                </div>
                <div className="table-header-cell">
                  <FontAwesomeIcon icon={faTrophy} />
                  <span>الدرجة</span>
                </div>
                <div className="table-header-cell">
                  <FontAwesomeIcon icon={faChartLine} />
                  <span>التقدم</span>
                </div>
                <div className="table-header-cell">
                  <FontAwesomeIcon icon={faUser} />
                  <span>النوع</span>
                </div>
                <div className="table-header-cell">
                  <FontAwesomeIcon icon={faCalendarCheck} />
                  <span>الحالة</span>
                </div>
                <div className="table-header-cell">
                  <FontAwesomeIcon icon={faBook} />
                  <span>المادة</span>
                </div>
              </div>
              
              <div className="attendance-table-body">
                {studentData?.categories?.map((category, categoryIndex) => 
                  category.courses.map((course, courseIndex) => (
                    <div key={`${categoryIndex}-${courseIndex}`} className="attendance-table-row">
                      <div className="table-cell date-cell">
                        <FontAwesomeIcon icon={faCalendarCheck} className="date-icon" />
                        <span>{course.attendance_date ? 
                          new Date(course.attendance_date).toLocaleString('ar-EG', {
                            year: 'numeric',
                            month: '2-digit',
                            day: '2-digit',
                            hour: '2-digit',
                            minute: '2-digit',
                            second: '2-digit'
                          }) : 
                          'غير محدد'
                        }</span>
                      </div>
                      
                      <div className="table-cell group-cell">
                        <Badge className="group-badge">
                          <FontAwesomeIcon icon={faUsers} className="me-1" />
                          {course.group_name || 'غير محدد'}
                        </Badge>
                      </div>
                      
                      <div className="table-cell grade-cell">
                        <FontAwesomeIcon icon={faTrophy} className="grade-icon" />
                        <span className="grade-value">
                          {course.exam_degree || 'لم يتم الامتحان'}
                        </span>
                      </div>
                      
                      <div className="table-cell progress-cell">
                        <div className="progress-container">
                          <div className="progress-bar">
                            <div 
                              className="progress-fill" 
                              style={{width: `${course.progress || 0}%`}}
                            ></div>
                          </div>
                          <span className="progress-percentage">
                            {course.progress || 0}%
                          </span>
                        </div>
                      </div>
                      
                      <div className="table-cell type-cell">
                        <Badge className="type-badge">
                          <FontAwesomeIcon icon={faUser} className="me-1" />
                          {course.attendance_type || 'غير محدد'}
                        </Badge>
                      </div>
                      
                      <div className="table-cell status-cell">
                        <Badge 
                          className={`status-badge ${course.attendance_status === 'حاضر' ? 'present' : 'absent'}`}
                        >
                          <FontAwesomeIcon 
                            icon={course.attendance_status === 'حاضر' ? faCalendarCheck : faCalendarTimes} 
                            className="me-1" 
                          />
                          {course.attendance_status === 'حاضر' ? 'حاضر' : 'غائب'}
                        </Badge>
                      </div>
                      
                      <div className="table-cell session-cell">
                        <FontAwesomeIcon icon={faBook} className="session-icon" />
                        <span>{course.name}</span>
                      </div>
                    </div>
                  ))
                )}
              </div>
            </div>

            {/* رسالة في حالة عدم وجود بيانات */}
            {(!studentData?.categories || studentData.categories.length === 0) && (
              <div className="no-content-container">
                <div className="icon-wrapper-not">
                  <span className="icon-line line-1"></span>
                  <span className="icon-line line-2"></span>
                </div>
                <h2>لا توجد بيانات حضور متاحة</h2>
                <p>لم يتم العثور على أي كورسات أو بيانات حضور.</p>
              </div>
            )}
          </Container>
        </main>
      </div>
    </>
  );
}

export default ParentDashboard;
